module.exports = __webpack_public_path__ + "img/result_empty.c6605b17.svg";